import { render, staticRenderFns } from "./pick_birds.vue?vue&type=template&id=a087125a&"
import script from "./pick_birds.vue?vue&type=script&lang=js&"
export * from "./pick_birds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports